import React from "react";
import { Route, Routes } from "react-router-dom";

import ROUTES_NAVIGATION from "./routes";

import AddCustomer from "../components/DealerManagement/Sales/CustomerList/AddCustomer";
import CustomerList from "../components/DealerManagement/Sales/CustomerList";
import DeliveryOrderList from "../components/DealerManagement/Sales/DeliveryOrderList";
import InvoiceList from "../components/DealerManagement/Sales/InvoiceList";
import PaymentRecieptList from "../components/DealerManagement/Sales/PaymentRecieptList";
import ProposalList from "../components/DealerManagement/Sales/ProposalList";
import QuotationApprovalList from "../components/DealerManagement/Sales/QuotationApprovalList";
import QuotationList from "../components/DealerManagement/Sales/QuotationList";
import StockAllotmentList from "../components/DealerManagement/Sales/StockAllotmentList";
import GatePass from "../components/DealerManagement/Sales/GatePass";
import SubsidyReconciliation from "../components/DealerManagement/Sales/SubsidyReconciliation";
import OrderCancel from "../components/DealerManagement/Sales/OrderCancel";
import OrderExchange from "../components/DealerManagement/Sales/OrderExchange";
// import ExtendedWarranty from "../components/DealerManagement/Sales/ExtendedWarranty";
// import ExtendedWarrantyApproval from "../components/DealerManagement/Sales/ExtendedWarrantyApproval";
import AddQuotation from "../components/DealerManagement/Sales/QuotationList/AddQuotation";
import AddProposal from "../components/DealerManagement/Sales/ProposalList/AddProposalList";
import EditSubsidy from "../components/DealerManagement/Sales/SubsidyReconciliation/EditSubsidy";
import AddCancelOrder from "../components/DealerManagement/Sales/OrderCancel/AddOrderCancel";
import AddOrderExchange from "../components/DealerManagement/Sales/OrderExchange/AddOrderCAncel";
// import AddExtendedWArranty from "../components/DealerManagement/Sales/ExtendedWarranty/AddExtendedWarranty";
// import CustomerDetails from "../components/DealerManagement/Sales/CustomerList/CustomerDetails";
import ViewQuotationList from "../components/DealerManagement/Sales/QuotationList/ViewQuotationList";
import ViewQuotationApproval from "../components/DealerManagement/Sales/QuotationApprovalList/ViewQuotationApproval";
import ViewProposal from "../components/DealerManagement/Sales/ProposalList/ViewProposal";
import ViewPaymentReceiptList from "../components/DealerManagement/Sales/PaymentRecieptList/ViewPaymentReceiptList";
import ViewStockAllotment from "../components/DealerManagement/Sales/StockAllotmentList/ViewStockAllotment";
import DeliveryOrderDetails from "../components/DealerManagement/Sales/DeliveryOrderList/deliveryOrderDetails";
import InvoiceDetails from "../components/DealerManagement/Sales/InvoiceList/Invoice Details";
import ViewGatePass from "../components/DealerManagement/Sales/GatePass/VIewGatePass";
import SubsidyDetails from "../components/DealerManagement/Sales/SubsidyReconciliation/ViewSubsidy";
import OrderCancelDetails from "../components/DealerManagement/Sales/OrderCancel/ViewOrderCancel";
import OrderExchangeDetails from "../components/DealerManagement/Sales/OrderExchange/ViewOrderDetails";
import ExtendedWArrantyApprovalDetails from "../components/DealerManagement/Sales/ExtendedWarrantyApproval/ViewExtendedWarrantyDetails";
import ExtendedWarrantyDetails from "../components/DealerManagement/Sales/ExtendedWarranty/ViewExtendedWarranty";
import CustomerDetailsList from "../components/DealerManagement/Sales/CustomerList/CustomerDetailsList";
import Dashboard from "../components/DealerManagement/Dashboard";
import EditCustomerForm from "../components/DealerManagement/Sales/CustomerList/EditCustomerList";
import EditQuotation from "../components/DealerManagement/Sales/QuotationList/EditQuotationList";
import EditProposal from "../components/DealerManagement/Sales/ProposalList/EditProposal";
import ProposalInvoice from "../components/DealerManagement/Sales/ProposalList/ProposalInvoice";
import OrderList from "../components/DealerManagement/Sales/ProductList";
import CreateNewOrder from "../components/DealerManagement/Sales/CreateOrder";
import ManageOrderList from "../components/DealerManagement/Sales/ManageOrder";
import OrderDetails from "../components/DealerManagement/Sales/ManageOrder/OrderDetails";
import SalesDashboard from "../components/DealerManagement/Sales/Dashboard/SalesDashboard";
import SalesMisReport from "../components/DealerManagement/Sales/MISREPORTSALES";
import ExtendedWarranty from "../components/DealerManagement/Admin/WarrantyManagement/ExtendedWarranty";
import GenerateOrder from "../components/DealerManagement/Sales/CreateOrder/GenerateOrder";
import CustomerPurchaseOrder from "../components/DealerManagement/Sales/CustomerPurchaseOrder";
import AddPurchaseOrder from "../components/DealerManagement/Sales/CustomerPurchaseOrder/AddPurchaseOrder";
import SalesCheckWarranty from "../components/DealerManagement/Sales/CheckWarranty";
import EditGenerateOrder from "../components/DealerManagement/Sales/EditGenerateOrder";
import PolicyMaster from "../components/DealerManagement/Sales/PolicyMaster";
import CustomerPurchaseOrderDetails from "../components/DealerManagement/Sales/CustomerPurchaseOrder/CustomerPurchaseOrderDetails/CustomerPurchaseOrderDetails";
import NewOffer from "../components/DealerManagement/Sales/NewOffer";
import WarrantyCheckDetailsAdmin from "../components/DealerManagement/Admin/WarrantyManagement/WarrantyCheck/WarrantyCheckDetails";
import CheckWarrantySalesDetails from "../components/DealerManagement/Sales/CheckWarranty/CheckWarrantyDetails";
import GracePeriodList from "../components/DealerManagement/Sales/GracePeriod";
import AddGracePeriod from "../components/DealerManagement/Sales/GracePeriod/AddGracePeriod";
// import EditGenerateOrder from "../components/DealerManagement/Sales/EditGenerateOrder";
import DealerSalesReport from "../components/DealerManagement/Sales/DealerSalesReport";
import DealerStockReport from "../components/DealerManagement/Sales/DealerStockReport";
import DealerWarrantyReport from "../components/DealerManagement/Sales/DealerWarrantyReport";
import JobCardReport from "../components/DealerManagement/Sales/JobCardReport";
import RiderSalesDetails from "../components/DealerManagement/Sales/RiderSalesDetails";
import EditPurchaseOrder from "../components/DealerManagement/Sales/CustomerPurchaseOrder/EditCustomerPurchaseOrder";
import Intransit from "../components/DealerManagement/Sales/ManageOrder/Intransit";
import SalesStockIn from "../components/DealerManagement/Sales/StockIn";
import AddStockInSales from "../components/DealerManagement/Sales/StockIn/AddStockIn";
import SalesVehicleReport from "../components/DealerManagement/Admin/MISReport/DealerStockVehicleReport";
import SoldCustomerPurchaseOrder from "../components/DealerManagement/Sales/InstockSoldVehicle";
import SoldAddPurchaseOrder from "../components/DealerManagement/Sales/InstockSoldVehicle/SoldAddPurchaseOrder";
import ServiceGenerateOrder from "../components/DealerManagement/Sales/CreateOrder/ServiceGenerateOrder";
import ServiceManageOrderList from "../components/DealerManagement/Sales/ManageOrder/serviceManageOrderList";

const SalesRoutes = () => {
  return (
    <>
      <Route
        path={ROUTES_NAVIGATION.SALESDASHBOARD}
        element={<SalesDashboard />}
      />

      <Route
        path={ROUTES_NAVIGATION.NEWOFFER}
        element={<NewOffer />}
      />

      <Route path={ROUTES_NAVIGATION.VIEWCUSTOMERPURCHASEORDER}
        element={<CustomerPurchaseOrderDetails />}
      />

<Route path={ROUTES_NAVIGATION.EDITCUSTOMERPURCHASEORDER}
        element={<EditPurchaseOrder />}
      />

      <Route
        path={ROUTES_NAVIGATION.POLICYMASTER}
        element={<PolicyMaster />}
      />

      <Route
        path={ROUTES_NAVIGATION.SALESDASHBOARDSALES}
        element={<SalesDashboard />}
      />

      <Route path={ROUTES_NAVIGATION.DEALERSALESREPORT}
        element={<DealerSalesReport />} />

      <Route path={ROUTES_NAVIGATION.DEALERSTOCKREPORT}
        element={<DealerStockReport />} />

      <Route path={ROUTES_NAVIGATION.DEALERWARRANTYREPORT}
        element={<DealerWarrantyReport />} />

      <Route path={ROUTES_NAVIGATION.JOBCARDREPORT}
        element={<JobCardReport />} />

      <Route path={ROUTES_NAVIGATION.RIDERSALESDETAILS}
        element={<RiderSalesDetails />} />

      <Route
        path={ROUTES_NAVIGATION.ADDSALESCUSTOMER}
        element={<AddCustomer />}
      />
      <Route
        path={ROUTES_NAVIGATION.SALESCUSTOMERLIST}
        element={<CustomerList />}
      />

      <Route
        path={ROUTES_NAVIGATION.EDITSALESCUSTOMER}
        element={<EditCustomerForm />}
      />

      <Route
        path={ROUTES_NAVIGATION.SALESDELIVERYORDERLIST}
        element={<DeliveryOrderList />}
      />
      <Route
        path={ROUTES_NAVIGATION.SALESINVOICELIST}
        element={<InvoiceList />}
      />
      <Route
        path={ROUTES_NAVIGATION.SALESPAYMENTRECEIPTLIST}
        element={<PaymentRecieptList />}
      />
      <Route
        path={ROUTES_NAVIGATION.SALESPROPOSALLIST}
        element={<ProposalList />}
      />
      <Route
        path={ROUTES_NAVIGATION.SALESQUOTATIONAPPROVALLIST}
        element={<QuotationApprovalList />}
      />
      <Route
        path={ROUTES_NAVIGATION.SALESQUOTATIONLIST}
        element={<QuotationList />}
      />
      <Route
        path={ROUTES_NAVIGATION.SALESSTOCKALLOTMENTLIST}
        element={<StockAllotmentList />}
      />

      <Route
        path={ROUTES_NAVIGATION.GATEPASS}
        element={<GatePass />}
      />

      <Route
        path={ROUTES_NAVIGATION.SUBSIDYRECONSCILLIATION}
        element={<SubsidyReconciliation />}
      />

      <Route
        path={ROUTES_NAVIGATION.ORDERCANCEL}
        element={<OrderCancel />}
      />

      <Route
        path={ROUTES_NAVIGATION.ORDEREXCHANGE}
        element={<OrderExchange />}
      />

      {/* <Route 
      path={ROUTES_NAVIGATION.EXTENDEDWARANTY}
      element={ <ExtendedWarranty/> }
      /> */}

      {/* <Route 
      path={ROUTES_NAVIGATION.EXTENDEDWARANTYAPPROVAL}
      element={<ExtendedWarrantyApproval /> }
      /> */}

      <Route
        path={ROUTES_NAVIGATION.ADDQUOTATION}
        element={<AddQuotation />}
      />

     <Route 
      path={ROUTES_NAVIGATION.GRACEPERIOD}
      element={<GracePeriodList/> }
      />

     <Route 
      path={ROUTES_NAVIGATION.ADDGRACEPERIOD}
      element={<AddGracePeriod/> }
      />

      <Route 
      path={ROUTES_NAVIGATION.EDITQUOTATION}
      element={ <EditQuotation/> }
      />

      <Route
        path={ROUTES_NAVIGATION.ADDPROPOSAL}
        element={<AddProposal />}
      />

      <Route
        path={ROUTES_NAVIGATION.EDITPROPOSAL}
        element={<EditProposal />}
      />

      <Route
        path={ROUTES_NAVIGATION.PROPOSALINVOICE}
        element={<ProposalInvoice />}
      />

      <Route
        path={ROUTES_NAVIGATION.EDITSUBSIDY}
        element={<EditSubsidy />}
      />

      <Route
        path={ROUTES_NAVIGATION.ADDCANCELORDER}
        element={<AddCancelOrder />}
      />

      <Route
        path={ROUTES_NAVIGATION.ADDORDEREXCHANGE}
        element={<AddOrderExchange />}
      />

      {/* <Route
      path={ROUTES_NAVIGATION.ADDEXTENDEDWARRANTY}
      element={ <AddExtendedWArranty /> }
      /> */}

      {/* <Route 
      path={ROUTES_NAVIGATION.CUSTOMERDETAILSLIST}
      element={ <CustomerDetailsList/> }
      /> */}


      <Route
        path={ROUTES_NAVIGATION.CUSTOMERDETAILSLIST}
        element={<CustomerDetailsList />}
      />



      <Route
        path={ROUTES_NAVIGATION.VIEWQUOTATIONLIST}
        element={<ViewQuotationList />}
      />

      <Route
        path={ROUTES_NAVIGATION.VIEWQUOTATIONAPPROVAL}
        element={<ViewQuotationApproval />}
      />

      <Route
        path={ROUTES_NAVIGATION.VIEWPROPOSALLIST}
        element={<ViewProposal />}
      />

      <Route
        path={ROUTES_NAVIGATION.VIEWPAYMENTRECEIPT}
        element={<ViewPaymentReceiptList />}
      />

      <Route
        path={ROUTES_NAVIGATION.VIEWSTOCKALLOTMENT}
        element={<ViewStockAllotment />}
      />

      <Route
        path={ROUTES_NAVIGATION.VIEWDELIVERYDETAILS}
        element={<DeliveryOrderDetails />}
      />

      <Route
        path={ROUTES_NAVIGATION.VIEWINVOICE}
        element={<InvoiceDetails />}
      />

      <Route
        path={ROUTES_NAVIGATION.VIEWGATEPASSS}
        element={<ViewGatePass />}
      />

      <Route
        path={ROUTES_NAVIGATION.VIEWSUBSIDY}
        element={<SubsidyDetails />}

      />

      <Route
        path={ROUTES_NAVIGATION.VIEWORDERCANCEL}
        element={<OrderCancelDetails />}
      />

      <Route
        path={ROUTES_NAVIGATION.VIEWORDEREXCHANGE}
        element={<OrderExchangeDetails />}
      />

      <Route
        path={ROUTES_NAVIGATION.VIEWEXTENDEDWARRANTYAPPROVAL}
        element={<ExtendedWArrantyApprovalDetails />}
      />

      <Route
        path={ROUTES_NAVIGATION.VIEWEXTENDEDWARRANTY}
        element={<ExtendedWarrantyDetails />}
      />
      <Route
        path={ROUTES_NAVIGATION.ORDERLIST}
        element={<OrderList />}
      />
      <Route
        path={ROUTES_NAVIGATION.CREATEORDER}
        element={<CreateNewOrder />}
      />
      <Route
        path={ROUTES_NAVIGATION.MANAGEORDERLIST}
        element={<ManageOrderList />}
      />
      <Route
        path={ROUTES_NAVIGATION.MANAGEORDERDETAILS}
        element={<OrderDetails />}
      />

      <Route
        path={ROUTES_NAVIGATION.SALESMISREPORT}
        element={<SalesMisReport />}
      />

      {/* <Route 
      path={ROUTES_NAVIGATION.SALESEXTENDEDWARRANTY}
      element={ <ExtendedWarranty/> }
      /> */}
      <Route
        path={ROUTES_NAVIGATION.SALESEXTENDEDWARRANTY}
        element={<ExtendedWarranty />}
      />

      <Route
        path={ROUTES_NAVIGATION.GENERATEORDER}
        element={<GenerateOrder />}
      />

      <Route 
      path={ROUTES_NAVIGATION.SERVICEMANAGEORDER}
      element={ <ServiceManageOrderList/> }
      />

      <Route
        path={ROUTES_NAVIGATION.SERVICEGENERATEORDER}
        element={<ServiceGenerateOrder />}
      />

      <Route
        path={ROUTES_NAVIGATION.EDITGENERATEORDER}
        element={<EditGenerateOrder />}
      />

      {/* CUSTOMERPURCHASEORDER */}

      <Route
        path={ROUTES_NAVIGATION.CUSTOMERPURCHASEORDER}
        element={<CustomerPurchaseOrder />}
      />

      <Route
        path={ROUTES_NAVIGATION.CUSTOMERPURCHASEORDERSIDEBAR}
        element={<CustomerPurchaseOrder />}
      />

      <Route
        path={ROUTES_NAVIGATION.ADDCUSTOMERPURCHASEORDER}
        element={<AddPurchaseOrder />}
      />

      <Route
        path={ROUTES_NAVIGATION.SALESWARRANTYCHECK}
        element={<SalesCheckWarranty />}
      />

      <Route
        path={ROUTES_NAVIGATION.SALESWARRANTYCHECKDETAILS}
        element={<CheckWarrantySalesDetails />}
      />

      <Route
        path={ROUTES_NAVIGATION.INTRANSIT}
        element={<Intransit />}
      />

      <Route
        path={ROUTES_NAVIGATION.STOCKINSALES}
        element={<SalesStockIn />}
      />

      {/* AddStockInSales */}

      <Route
        path={ROUTES_NAVIGATION.ADDSTOCKINSALES}
        element={<AddStockInSales />}
      />

      <Route
      path={ROUTES_NAVIGATION.SALESSTOCKDETAILSVEHICLES}
      element={<SalesVehicleReport/> }
      /> 

      <Route 
      path={ROUTES_NAVIGATION.SOLDVEHICLECUSTOMERSTOCKIN}
      element={ <SoldCustomerPurchaseOrder/> }
      />

      <Route 
      path={ROUTES_NAVIGATION.ADDSOLDVEHICLESERIALS}
      element={ <SoldAddPurchaseOrder/> }
      />

    </>
  );
};

export default SalesRoutes;
